import React from 'react';
import DropTrackProductsList from './Components/DropTrackProductsList/DropTrackProductsList.js'
import Modal from './Components/Modal/Modal';
import { useSelector } from 'react-redux';

function DropTrackProducts() {
    const modalDisplay = useSelector((state) => state.dropTrackProducts.modalDisplay);

    return (
        <div className="w-full overflow-y-scroll pb-16 outline-none">
            <div className="flex items-center justify-between gap-6 relative m-[20px_19px_24px_20px]">
                <div className="w-fit flex items-center">
                    <h1 className="p-[6px] text-[#121212] font-bold text-2xl select-none">DropTrack Products</h1>
                </div>
            </div>

            {/* List of Products */}
            <DropTrackProductsList />

            {/* Modal */}
            {modalDisplay && <Modal />}
        </div>
    );
}

export default DropTrackProducts;
